export const LOOP_DURATION = 12 // seconds
export const NOISE_PERIOD_REPEAT = 3
export const VIDEO_SIZE = 1080 // px

export const EXPORT_DPR = 1 // 1080 * 1 = 1080
export const EXPORT_KBPS = 33000 // Limits around 50MB
export const EXPORT_FPS = 60
export const EXPORT_PRIORITY = 10000
export const EXPORT_ANIMATION_DURATION = 1000 // ms

export const MAX_SPOTLIGHTS = 5
